<template>
  <div class="content">
        
        <img v-if="seller.logo && !seller.bannerImage" :src="getImgUrl(seller.logo)" alt="logo" :style="styleChange" />
        <img v-if="seller.bannerImage" :src="getImgUrl(seller.bannerImage)" alt="banner" style="width: 100%;max-height: 260px;" />
      
        <div class="index-content">       
        <div style="text-align: center;padding-top: 40px;font-size: 18px;font-weight: 600;"> {{$t('buffetselect.dinnerAsk')}}</div>
          
          <mu-form ref="form" :model="tableOrderInfo" class="mu-demo-form">
              <div style="margin:10px;text-align: center;">
                 {{$t('buffetselect.selectDinnerNum')}}
              </div>

              <div style="padding-left: 25px;">
                  <div class="badge-num" :class="{select:index==current}" @click="selectNum(index,item)" v-for="(item,index) in options" :key="index">{{item}}</div>
              </div>
              <mu-form-item :label="$t('buffetselect.moreNumBtn')" prop="number" style="padding-left: 25px;width: 100%" v-if="isMore">
                  <mu-text-field v-model="tableOrderInfo.number" prop="number" :rules="[{type:'number',required: false, message: 'Please enter the number type', trigger: 'blur,change'}]"></mu-text-field>
              </mu-form-item>
              <mu-form-item  :label="$t('buffetselect.tasteRequired')" prop="specielle" style="padding-left: 25px;width: 100%" >
                  <mu-text-field v-model="tableOrderInfo.specielle" prop="specielle"></mu-text-field>
              </mu-form-item>
              <mu-form-item style="margin:auto;text-align:center;">
                  <mu-button color="success" large full-width @click="startOrdering" style="background-color:#da5b3a;width:94%;text-transform: unset;">
                      {{$t('buffetselect.startOrder')}}
                  </mu-button>
              </mu-form-item>
          </mu-form>
      </div>
  </div>
</template>

<script>
import crypto from 'crypto'
export default {
  data() {
        return {
            current: 0,
            tableOrderInfo: {},
            styleChange: {},
            seller:{},
            isMore: false,
            options: [
                '1', '2', '3', '4',
                '5', '6', '7', '8',
                'more',
            ],
            fullscreen: false,
        }
        },
        created() {
            
        },
        mounted() {
            this.tableOrderInfo = this.getItem('sessionStorage','tableOrderInfo');
            this.seller=JSON.parse(localStorage.getItem('seller'));
            let img = new Image()
                            img.src = this.getImgUrl(this.seller.logo)
                                if (img.width == img.height) {
                                    this.styleChange = {
                                        width: '100px',
                                        height: '100px',
                                        display: 'block',
                                        margin: '10% auto',  
                                        borderRadius: '50px'
                                    }        
                                }
                                else {
                                    this.styleChange = {
                                        width: '128px',
                                        height: '96px',
                                        display: 'block',
                                        margin: '10% auto'
                                    }
                            }
            if (this.tableOrderInfo.tableName == undefined || this.tableOrderInfo.tableName == null) {
                this.$router.push({
                    path: '/error',
                    query: {}
                })
            }

            this.$get('QRCodeOrder/GetUnpayOrderMainByTableName', {
                    tableName: this.tableOrderInfo.tableName,
                    restaurantId: this.tableOrderInfo.restaurantId
                })
                    .then(response => {
                        if (response.code==200) {
                            var data = response.data;
                            if (data != null && data != '') {
                                this.current=parseInt(data.adult);
                                if(this.$route.query.modifyNum==undefined || this.$route.query.modifyNum==null){
                                    this.$router.push({
                                    path: '/goodsMain', query: {
                                        isSeft:0
                                    } });
                                }                       
                            }
                        }
                    });
         
        },
        methods: {
            getImgUrl(image) {
                if (image == undefined || image == 'undefined') {
                    return null;
                }
                return this.imageBaseUrl + image;
            },
            startOrdering() {
                if (this.tableOrderInfo.number == null || this.tableOrderInfo.number == "" || this.tableOrderInfo.number == 0) {
                    this.$alert($t('buffetselect.selectDinnerNum'), $t('common.alert'), { okLabel: $t('common.ok') });
                    return;
                }
                this.$refs.form.validate().then((result) => {
                    if (result) {
                                window.localStorage.setItem('tableOrderInfo', JSON.stringify(this.tableOrderInfo));
                                this.$router.push({
                                    path: '/goodsMain', query: {isSeft:0
                                    } });
                    }
                });
            },
            selectNum(index, item) {
                this.current = index;
                if (item != 'more') {
                    this.isMore = false;
                    this.tableOrderInfo.number = item;
                }
                else {
                    this.isMore=true;
                }
            },
            backIndex() {
                this.$router.push({ path: '/index' });
            },
         handleFullScreen(){
        let element = document.documentElement;
        if (this.fullscreen) {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.webkitCancelFullScreen) {
                document.webkitCancelFullScreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            }
        } else {
            if (element.requestFullscreen) {
                element.requestFullscreen();
            } else if (element.webkitRequestFullScreen) {
                element.webkitRequestFullScreen();
            } else if (element.mozRequestFullScreen) {
                element.mozRequestFullScreen();
            } else if (element.msRequestFullscreen) {
                // IE11
                element.msRequestFullscreen();
            }
        }
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
    .content {
        position: fixed;
        top: 0;
        bottom: 0;
        width: 100%;
        background-color:#fff;
    }
  .user {
    width: 40px;
    height: 40px;
    display: block;
    margin: 0 auto;
    margin-top: 50px;
  }
    .index-content {
        padding: 0 24px;
        height: 100%;
    }
    .badge-num {
        float:left;
        width: 60px;
        height: 32px;
        margin-right: 5px;
        margin-bottom:5px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        padding: 0 6px;
        line-height: 1.5;
        font-size: 14px;
        font-style: normal;
        background-color: #bdbdbd;
        color: #fff;
        border-radius: 3px;
        overflow: hidden;
    
    }
    .select {
        background-color: rgb(218, 91, 58);
    }

    .back-btn {
        position: absolute;
        top: 15px;
        left: 15px;
        width: 32px;
        height: 32px;
        z-index: 999;
    }
        .back-btn img {
            width: 32px;
            height: 32px;
        }
</style>



// WEBPACK FOOTER //
// src/components/DinersNum.vue